// Bridge modul musí být importován absolutně, aby fungovalo jeho mockování při strict buildech (compile:react:dry, testy, storybook).
import { bridge } from "@multiweb/reactCore/bridge";
import { ApplicationModule } from "@multiweb/types/react";
import { authModule } from "./auth";
import { dataSourceModule } from "./datasource";
import { enumsModule } from "./enums";
import { fetchingModule } from "./fetching";
import { i18nModule } from "./i18n";
import { themeModule } from "./theme";

const { module: bridgeModule } = bridge;

export { NAME } from "./constants";

/**
 * Seznam core modulů. Pokud modul obsahuje ságu, je automaticky spuštěna. Pokud modul obsahuje reducer, je pod jménem modulu automaticky zapojen do core části stavu.
 */
export const coreModules: Array<ApplicationModule<string>> = [
    authModule,
    bridgeModule,
    i18nModule,
    fetchingModule,
    themeModule,
    dataSourceModule,
    enumsModule,
];
